import {
    FETCH_OWNER_LIST_REQUEST,
    FETCH_OWNER_LIST_SUCCESS,
    FETCH_OWNER_LIST_FAILURE,

    CREATE_OWNER_REQUEST,
    CREATE_OWNER_SUCCESS,
    CREATE_OWNER_FAILURE,

    UPDATE_OWNER_REQUEST,
    UPDATE_OWNER_SUCCESS,
    UPDATE_OWNER_FAILURE
} from './types';


/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const fetchOwnerListRequest = (params) => ({
    type: FETCH_OWNER_LIST_REQUEST,
    payload: params
});

/**
 *
 * @param {BrokerFirmListState} data
 * @returns
 */
export const fetchOwnerListSuccess = (data) => ({
    type: FETCH_OWNER_LIST_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function fetchOwnerListFailure(error) {
    return {
        type: FETCH_OWNER_LIST_FAILURE,
        error
    };
}




/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const createOwnerRequest = (params) => ({
    type: CREATE_OWNER_REQUEST,
    payload: params
});

export const createOwnerSuccess = (data) => ({
    type: CREATE_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createOwnerFailure(error) {
    return {
        type: CREATE_OWNER_FAILURE,
        error
    };
}



/**
 *
 * @param {BrokerFirm} params
 * @returns
 */
 export const updateOwnerRequest = (params) => ({
    type: UPDATE_OWNER_REQUEST,
    payload: params
});

export const updateOwnerSuccess = (data) => ({
    type: UPDATE_OWNER_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateOwnerFailure(error) {
    return {
        type: UPDATE_OWNER_FAILURE,
        error
    };
}
